import React, { Component } from 'react'
import ClassConductsPV from './ClassConductsPV'
import AuthA from '../../store/actions/AuthA'

import axios from 'axios'
import sortBy from 'lodash/sortBy'
import find from 'lodash/find'
import filter from 'lodash/filter'
import constantCase from 'constant-case'
import paramCase from 'param-case'
import {connect} from 'react-redux'

import { resolveGradingScheme, periodDbField } from '../../utils/gradingScheme'

const _ = { sortBy, find, filter }

const changeCase = {
  constantCase: constantCase,
  paramCase: paramCase,
}

// Was a literal four-quarter map, duplicated in the PV. On a three-term year
// quarter 4 resolved to 'fourthQuarter' and wrote conduct into the column the
// migration left dormant, and the PV rendered it back as though it were real.
const periodField = (quarter, scheme) =>
  periodDbField(quarter, scheme ? scheme.periods.length : undefined);

// Which semester a period belongs to, for the 2016 SHS curriculum. Under four
// quarters that is 1,2 -> sem 1 and 3,4 -> sem 2; under three terms the split
// comes from the school year, since three terms cannot divide evenly in two.
const semesterFor = (scheme, quarter) => {
  const index = parseInt(quarter, 10);
  const semesters = scheme && scheme.semesters
    ? scheme.semesters
    : [{ index: 1, terms: [1, 2] }, { index: 2, terms: [3, 4] }];
  const match = semesters.filter((s) => s.terms.indexOf(index) !== -1)[0];
  return match ? match.index : null;
};

class ClassConductsPC extends Component {
  // Resolves how this section is graded. Returns null until the section and its
  // school year have loaded, in which case periodField falls back to the legacy
  // four-quarter columns - the same behaviour as before.
  getScheme = () => {
    const section = this.state.section && this.state.section[0];
    if (!section || !section.schoolYear) return null;
    return resolveGradingScheme(section.schoolYear, section.gradeLevel, {
      levelType: section.levelType,
    });
  }

  constructor(props) {
    super(props);
    this.state = {
      classConducts: [],
      section: [],
      sectionId: '',
      column: null,
      direction: null,
      sectionStudents: [],
      error: false,
      success: false,
      fileName: '',
      classConductSheet: null,
      areClassConductsSaved: false,
      quarter: 1,
      modalOpen: false,
      sectionSubjects: [],
      subjectConducts: [],
      sectionStudentId: '',
      dirtyInput: false,
      open: false,
      created: [],
      checked: [],
      reviewed: [],
      sections: []
    };
    this.getClassConducts = this.getClassConducts.bind(this);
    this.getSubjectConducts = this.getSubjectConducts.bind(this);
    this.getSectionStudents = this.getSectionStudents.bind(this);
    this.handleSort = this.handleSort.bind(this);
    this.handleUpdateSectionDetails = this.handleUpdateSectionDetails.bind(this);
  }

  getClassConducts(sectionId, section) {
    const { sectionStudents, quarter } = this.state;
    axios.get(process.env.REACT_APP_URL+'/classConducts?filter[where][active]=true&filter[where][sectionId]='+sectionId)
    .then(response => {
      this.setState({ classConducts: response.data}, () => {
        if (response.data.length !== 0) {
          this.getSubjectConducts(this.state.sectionId, section);
          sectionStudents.map((sectionStudent, key )=> {
            const studentName = sectionStudent.student.lastName +', '+sectionStudent.student.firstName;
            const studentVariable = changeCase.constantCase(studentName);
            const classConduct = _.find(response.data, {
              sectionStudentId: sectionStudent.sectionStudentId
            });

            if (classConduct != null) {
              // The quarter arrives from the URL as a string, and this used to
              // compare it with === against '1'..'4', so a numeric quarter
              // matched nothing and the row silently loaded blank.
              const field = periodField(quarter, this.getScheme());
              if (field) {
                this.setState({
                  [`${studentVariable}-1`]: classConduct[`${field}1`],
                  [`${studentVariable}-2`]: classConduct[`${field}2`],
                  [`${studentVariable}-3`]: classConduct[`${field}3`],
                  [`${studentVariable}`]: classConduct[field],
                  [`${studentVariable}-S`]: classConduct[`${field}Subjects`],
                  [`${studentVariable}-FG`]: classConduct[`${field}Final`],
                  areClassConductsSaved: true
                })
              }
              return true;
            } else {
              this.setState({
                [`${studentVariable}-1`]: 0,
                [`${studentVariable}-2`]: 0,
                [`${studentVariable}-3`]: 0,
                [`${studentVariable}`]: 0,
                [`${studentVariable}-S`]: 0,
                [`${studentVariable}-FG`]: 0,
                areClassConductsSaved: true
              })

              return true;
            }

          })
        } else {
          sectionStudents.map((sectionStudent, key )=> {
            const studentName = sectionStudent.student.lastName +', '+sectionStudent.student.firstName;
            const studentVariable = changeCase.constantCase(studentName);
            this.getSubjectConducts(this.state.sectionId, section)
            this.setState({
              [`${studentVariable}-1`]: 0,
              [`${studentVariable}-2`]: 0,
              [`${studentVariable}-3`]: 0,
              [`${studentVariable}`]: 0,
              [`${studentVariable}-S`]: 0,
              [`${studentVariable}-FG`]: 0,
              areClassConductsSaved: true
            })

            return true;
          })
        }
      });
    });
  }

  getSubjectConducts(sectionId, section) {
    const {sectionStudents, quarter} = this.state
    axios.get(process.env.REACT_APP_URL+'/conducts/section?sectionId='+sectionId)
    .then(response => {
        let sectionSubjectsFiltered = [];
        if (section.length !== 0) {
          // Only the 2016 SHS curriculum splits subjects by semester. The
          // Strengthened Grade 11 level types are deliberately absent here, so
          // they fall through to the whole-year list.
          const isLegacySHS = section[0].levelType === 'SHSSTEM' ||
            section[0].levelType === 'SHSHUMSS' ||
            section[0].levelType === 'SHSABM';

          const scheme = resolveGradingScheme(
            section[0].schoolYear,
            section[0].gradeLevel,
            { levelType: section[0].levelType }
          );

          // ...and only until SY 2026-2027, when Grade 12 started running those
          // subjects across the whole year. Splitting them after that drops
          // every conduct in the terms the filter calls the other semester:
          // with all subjects marked semester 1, a Term 3 conduct matched
          // nothing and the section's conduct totals silently came out empty.
          if (isLegacySHS && scheme.mode === 'numeric-4q') {
            const semester = semesterFor(scheme, quarter);
            if (semester) {
              sectionSubjectsFiltered = _.filter(response.data.sectionSubjects, (sectionSubject) =>
                // sem defaults to "" and is never set on creation, so guard it
                // rather than throwing on a legacy record.
                Boolean(sectionSubject.sem) && sectionSubject.sem.includes(String(semester))
              );
            } else {
              sectionSubjectsFiltered = response.data.sectionSubjects;
            }
          } else {
            sectionSubjectsFiltered = response.data.sectionSubjects;
          }
        }

        sectionStudents.map((sectionStudent, key )=> {
          const studentName = sectionStudent.student.lastName +', '+sectionStudent.student.firstName;
          const studentVariable = changeCase.constantCase(studentName);

          let totalConduct = 0;
          response.data.conducts.map((conduct, key) => {
            const conductHasSubject = _.find(sectionSubjectsFiltered, (sectionSubject) => {
              if (sectionSubject.sectionSubjectId === conduct.sectionSubjectId) {
                return true
              } else {
                return false;
              }
            });
            if (sectionStudent.sectionStudentId === conduct.sectionStudentId && conductHasSubject) {
              const conductField = periodField(quarter, this.getScheme());
              if (conductField) {
                totalConduct = totalConduct + parseInt(conduct[conductField], 10);
              }
            } else {
              totalConduct = totalConduct + 0;
            }
            return true;
          })
          let average = totalConduct / sectionSubjectsFiltered.length;
          average = parseFloat(average.toFixed(2))
          if(this.state[`${studentVariable}-S`] !== average) {
            let final = average + 60 + parseFloat(this.state[`${studentVariable}`]);
            final = parseFloat(final.toFixed(2))
            this.setState({
              [`${studentVariable}-S`]: average,
              [`${studentVariable}-FG`]: final,
              dirtyInput: true
            })
          }

          return true;
        })

      this.setState({ sectionSubjects: sectionSubjectsFiltered, subjectConducts: response.data.conducts});
    });
  }


  getSection = (sectionId) => {
    axios.get(process.env.REACT_APP_URL+'/sections?filter[where][active]=true&filter[include]=details&filter[include]=schoolYear&filter[where][sectionId]='+sectionId)
    .then(async(response) => {

      await this.getSectionDetailsForChecking();
      await this.getSectionDetailsForReview();
      await this.getSectionDetailsForApproval();
      await this.getSections();
      await this.getSectionStudents(sectionId, response.data);
      this.setState({ section: response.data});
    })
  }

  getSectionDetailsForChecking = async() => {
    await axios.get(process.env.REACT_APP_URL+`/sectionDetails?filter[where][active]=true&filter[include]=section&filter[where][status]=Created&filter[where][type]=conduct&filter[where][quarter]=${this.state.quarter}`)
    .then(response => {
      this.setState({created: response.data})
    });
  }

  getSectionDetailsForReview = async() => {
    await axios.get(process.env.REACT_APP_URL+`/sectionDetails?filter[where][active]=true&filter[include]=section&filter[where][status]=Checked&filter[where][type]=conduct&filter[where][quarter]=${this.state.quarter}`)
    .then(response => {
      this.setState({checked: response.data})
    });
  }

  getSectionDetailsForApproval = async() => {
    await axios.get(process.env.REACT_APP_URL+`/sectionDetails?filter[where][active]=true&filter[include]=section&filter[where][status]=Reviewed&filter[where][type]=conduct&filter[where][quarter]=${this.state.quarter}`)
    .then(response => {
      this.setState({reviewed: response.data})
    });
  }

  getSections = async() => {
    await axios.get(process.env.REACT_APP_URL+'/sections?filter[where][active]=true')
    .then(response => {
      this.setState({ sections: response.data });
    });
  }

  getSectionStudents(sectionId, section) {
    axios.get(process.env.REACT_APP_URL+'/sectionStudents?filter[where][active]=true&filter[include]=student&filter[where][sectionId]='+sectionId)
    .then(response => {
      const sorted = _.sortBy(response.data, function(o){return [o.student.lastName, o.student.firstName]})
      this.setState({ sectionStudents: sorted }, () => {
        this.getClassConducts(this.state.sectionId, section);
      });
    });
  }

  handleApprovalOpen = () => {
    this.setState({
      open: true
    })
  }

  handleApprovalClose = () => this.setState({
    open: false
  })

  handleOpen = (sectionStudentId) => {
    this.setState({
      modalOpen: true,
      sectionStudentId: sectionStudentId
    })
  }

  handleClose = () => this.setState({
    modalOpen: false,
    sectionStudentId: ''
  })

  handleSort(clickedColumn) {
    const { column, sectionStudents, direction } = this.state
    if (column !== clickedColumn) {
      if(clickedColumn === 'name') {
        this.setState({
          column: clickedColumn,
          sectionStudents: _.sortBy(sectionStudents, function(o){return o.student.lastName}),
          direction: 'ascending',
        })
        return
      } else {
        this.setState({
          column: clickedColumn,
          sectionStudents: _.sortBy(sectionStudents, [clickedColumn]),
          direction: 'ascending',
        })
        return
      }
    }
    this.setState({
      sectionStudents: sectionStudents.reverse(),
      direction: direction === 'ascending' ? 'descending' : 'ascending',
    })
  }

  handleChange = (e, { name, value }) => {
    if (name.includes('-')) {
      const stateName = name.split('-');
      let total=0;
      const changedNumber = isNaN(parseInt(value)) ? 0 : parseInt(value);

      for(let i = 1; i < 4; i++) {
        if(parseInt(stateName[1]) !== i) {
          total = parseInt(total) + parseInt(this.state[`${stateName[0]}-${i}`])
        }
      }
      total = parseInt(total) + changedNumber;
      const final = total + this.state[`${stateName[0]}-S`] + 60;
      this.setState({[stateName[0]]: total, [`${stateName[0]}-FG`]: Math.round(final), [name]: value, dirtyInput: true})
    } else {
      this.setState({[name]: value, dirtyInput: true})
    }
  }

  handleUpdateSectionDetails(data, id) {
    const url = process.env.REACT_APP_URL+'/sectionDetails/'+id;
    axios
      .request({
        method: 'put',
        url: url,
        data: data
      })
      .then(response => {
        this.setState({open: false}, this.getSection(this.state.sectionId))

      })
      .catch(err => console.log(err));
  }

  handleSubmit = () => {
    const {sectionStudents, quarter} = this.state;

    // Validations
    let hasInvalidValue = sectionStudents.some((sectionStudent) => {
      const studentName = sectionStudent.student.lastName +', '+sectionStudent.student.firstName;
      const studentVariable = changeCase.constantCase(studentName);

      if(this.state[studentVariable] === undefined) {
        return true;
      }

      return parseInt(this.state[studentVariable],10) < 1 || parseInt(this.state[studentVariable],10) > 15 || this.state[studentVariable] === ''
    });

    if (hasInvalidValue) {
      this.setState({error: hasInvalidValue, success: false})
    } else {
      sectionStudents.map((sectionStudent, key )=> {
        const studentName = sectionStudent.student.lastName +', '+sectionStudent.student.firstName;
        const studentVariable = changeCase.constantCase(studentName);

        const sectionStudentId = sectionStudent.sectionStudentId;
        const sectionId = this.state.sectionId;

        const quarterLabel = periodField(quarter, this.getScheme());

        const data = {
          sectionStudentId: sectionStudentId,
          sectionId: sectionId,
          [quarterLabel]:  this.state[studentVariable],
          [`${quarterLabel}1`]:  this.state[`${studentVariable}-1`],
          [`${quarterLabel}2`]:  this.state[`${studentVariable}-2`],
          [`${quarterLabel}3`]:  this.state[`${studentVariable}-3`],
          [`${quarterLabel}Subjects`]:  this.state[`${studentVariable}-S`],
          [`${quarterLabel}Final`]:  this.state[`${studentVariable}-FG`]
        }

        const url = process.env.REACT_APP_URL+'/classConducts/upsertWithWhere?where={"sectionId":"'+sectionId+'","sectionStudentId":"'+sectionStudentId+'"}';
        axios
          .request({
            method: 'post',
            url: url,
            data: data
          })
          .then(response => {
            if (key === sectionStudents.length-1) {
              this.setState({success: true}, () => this.getClassConducts(sectionId, this.state.section));
            }
          })
          .catch(err => console.log(err));

        return true;
      })
      this.setState({success: true, error: false, dirtyInput: false, open: true})
    }
  }

  componentDidMount() {
    this.props.authFn.getToken()
    this.props.onContentMount({title:'Class Conduct'});

    const sectionId = this.props.match.params.sectionId;
    const params = new URLSearchParams(this.props.location.search);
    const quarter = params.get('quarter');
    this.setState({quarter: quarter, sectionId: sectionId}, () => {
      this.getSection(sectionId);

    })

  }

  componentDidUpdate(prevProps) {
    const sectionId = this.props.match.params.sectionId;
    const prevSectionId = prevProps.match.params.sectionId;
    const params = new URLSearchParams(this.props.location.search);
    const prevParams = new URLSearchParams(prevProps.location.search);
    const quarter = params.get('quarter');
    const prevQuarter = prevParams.get('quarter');

    // Only update if section or quarter actually changed
    const hasChanged = sectionId !== prevSectionId || quarter !== prevQuarter;

    if (!hasChanged) {
      return; // Prevent duplicate API calls
    }

    // Clear any existing timeout
    if (this.updateTimeout) {
      clearTimeout(this.updateTimeout);
    }

    // Add 1 second delay before making API calls
    this.updateTimeout = setTimeout(() => {
      this.setState({quarter: quarter, sectionId: sectionId}, () => {
        this.getSection(sectionId);
      });
    }, 1000);
  }

  render() {
    return (
      <ClassConductsPV
        auth={this.props.auth}
        username={this.props.username}
        userType={this.props.userType}
        userId={this.props.userId}
        scheme={this.getScheme()}
        column={this.state.column}
        direction={this.state.direction}
        section={this.state.section}
        quarter={this.state.quarter}
        sectionStudents={this.state.sectionStudents}
        error={this.state.error}
        success={this.state.success}
        areClassConductsSaved={this.state.areClassConductsSaved}
        modalOpen={this.state.modalOpen}
        open={this.state.open}
        subjectConducts={this.state.subjectConducts}
        sectionSubjects={this.state.sectionSubjects}
        sectionStudentId={this.state.sectionStudentId}
        dirtyInput={this.state.dirtyInput}
        created={this.state.created}
        checked={this.state.checked}
        reviewed={this.state.reviewed}
        sections={this.state.sections}
        {...this.state}
        handleApprovalOpen={this.handleApprovalOpen}
        handleApprovalClose={this.handleApprovalClose}
        handleOpen={this.handleOpen}
        handleClose={this.handleClose}
        handleSort={this.handleSort}
        handleChange={this.handleChange}
        handleSubmit={this.handleSubmit}
        handleUpdateSectionDetails={this.handleUpdateSectionDetails}
      />
    );
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    authFn: AuthA(dispatch)
  }
}

const mapStateToProps = (state) => {
  return {
    auth: state.AuthR.auth,
    username: state.AuthR.username,
    userType: state.AuthR.userType,
    userId: state.AuthR.userId
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(ClassConductsPC);
